import FilterNodes from './FilterNodes';
import Observer from 'utilities/Observer';

/**
 * c-expandable must have html :
 * 1 <A> the collapsable button
 * 2 <Div>
 *
 * todo : won't collapse yet
 */
class Expandable extends HTMLElement {
	constructor() {
		super();

		this.alsoToggle = this.attributes.alsoToggle;
		this.expandButton = FilterNodes([...this.children], 'A')[0];
		this.contentBlock = FilterNodes([...this.children], 'DIV')[0];

		if (!this.expandButton) throw Error('no button found <A>');
		if (!this.contentBlock) throw Error('no content block found <DIV>');

		this.contentHeight = this.calcContentHeight([...this.contentBlock.children]) + 60;
		this.addListeners();

		this.automaticlyExpand();
	}

	automaticlyExpand() {
		if (window.innerWidth < 500) {
			this.expandButton.classList.add('expand');
			this.contentBlock.style.maxHeight = `${this.contentHeight}px`;
			if (this.alsoToggle.value === 'parent') this.parentNode.classList.add('expand');
		} else {
			let menuVisible = new Observer(window.app.menuVisible);
			menuVisible.subscribe((state) => {
				this.expandButton.classList.add('expand');
				this.contentBlock.style.maxHeight = `${this.contentHeight}px`;
				if (this.alsoToggle.value === 'parent') this.parentNode.classList.add('expand');
				window.app.menuVisible.unregisterObserver(menuVisible);
			});
		}
	}

	calcContentHeight(contentBlock) {
		return contentBlock.reduce((total, el) => {
			return total + parseInt(window.getComputedStyle(el).getPropertyValue('height'));
		}, 0);
	}

	addListeners() {
		this.expandButton.addEventListener('click', (el) => {
			el.preventDefault();
			this.expandButton.classList.toggle('expand');
			this.contentBlock.style.maxHeight = `${this.contentHeight}px`;

			if (this.alsoToggle) {
				if (this.alsoToggle.value === 'parent') this.parentNode.classList.toggle('expand');
			}
		}, {passive: true});
	}

	getElement(className) {
		return [...this.children].filter((el) => {
			if (el.classList.contains(className)) return el;
		})[0];
	}
}

export default Expandable;
